import Add from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { Box, Stack, styled, Typography } from "@mui/material";
import image1 from "assets/image/new feautre/feautre/image1.png";
import image1_1 from "assets/image/new feautre/feautre/image1_1.png";
import image1_2 from "assets/image/new feautre/feautre/image1_2.png";
import image1_3 from "assets/image/new feautre/feautre/image1_3.png";
import image1_4 from "assets/image/new feautre/feautre/image1_4.png";
import image1_5 from "assets/image/new feautre/feautre/image1_5.png";
import image1_6 from "assets/image/new feautre/feautre/image1_6.png";
import image1_7 from "assets/image/new feautre/feautre/image1_7.png";
import image1_8 from "assets/image/new feautre/feautre/image1_8.png";
import image1_9 from "assets/image/new feautre/feautre/image1_9.png";
import image2 from "assets/image/new feautre/feautre/image2.png";
import image2_1 from "assets/image/new feautre/feautre/image2_1.png";
import image2_2 from "assets/image/new feautre/feautre/image2_2.png";
import image2_3 from "assets/image/new feautre/feautre/image2_3.png";
import image3 from "assets/image/new feautre/feautre/image3.png";
import image4 from "assets/image/new feautre/feautre/image4.png";
import image4_1 from "assets/image/new feautre/feautre/image4_1.png";
import image5 from "assets/image/new feautre/feautre/image5.png";
import image5_1 from "assets/image/new feautre/feautre/image5_1.png";

import newFeature1_1 from "assets/image/new feautre/feautre/whiteness1_1.png";
import newFeature1_2 from "assets/image/new feautre/feautre/whiteness1_2.png";
import newFeature2 from "assets/image/new feautre/feautre/whiteness2.png";
import newFeature3_1 from "assets/image/new feautre/feautre/whiteness3_1.png";
import newFeature3_2 from "assets/image/new feautre/feautre/whiteness3_2.png";

import { Trans } from "react-i18next";

import { FLAG_WHAT_IS_NEW } from "state/useFlag";

export const Image = styled("img")`
  max-width: 360px;
  width: 100%;
  object-fit: cover;
  borderradius: 4px;
`;

type NavListType = {
  id: number;
  title: string;
  isNew: boolean;
  isHidden?: boolean;
  key: FLAG_WHAT_IS_NEW | FLAG_WHAT_IS_NEW[];
  toGetKeyNumber?: any;
};
export const navList = (t, isFeature): NavListType[] => [
  {
    id: 1,
    title: t("newFeature:1.navLabel"),
    isNew: true,
    isHidden: false,
    key: [FLAG_WHAT_IS_NEW.setting],
  },
  {
    id: 2,
    title: t("newFeature:2.navLabel"),
    isNew: true,
    isHidden: false,
    key: [FLAG_WHAT_IS_NEW.inspect, FLAG_WHAT_IS_NEW.setting],
  },
  {
    id: 3,
    title: t("newFeature:3.navLabel"),
    isNew: true,
    isHidden: false,
    key: [FLAG_WHAT_IS_NEW.inspect],
  },
  {
    id: 4,
    title: t("newFeature:4.navLabel"),
    isNew: true,
    isHidden: false,
    key: [FLAG_WHAT_IS_NEW.profile, FLAG_WHAT_IS_NEW.result],
  },
  {
    id: 5,
    title: t("newFeature:5.navLabel"),
    isNew: true,
    isHidden: false,
    key: [FLAG_WHAT_IS_NEW.setting],
  },
  {
    id: 6,
    title: t("newFeature:6.navLabel"),
    isNew: true,
    isHidden: false,
    key: [
      FLAG_WHAT_IS_NEW.whiteness_inspect,
      FLAG_WHAT_IS_NEW.whiteness_history,
      FLAG_WHAT_IS_NEW.whiteness_result,
    ],
    toGetKeyNumber: FLAG_WHAT_IS_NEW.whiteness_inspect,
  },
  {
    id: 7,
    title: t("newFeature:7.navLabel"),
    isNew: true,
    isHidden: false,
    key: [
      FLAG_WHAT_IS_NEW.whiteness_history,
      FLAG_WHAT_IS_NEW.whiteness_inspect,
      FLAG_WHAT_IS_NEW.whiteness_result,
    ],
    toGetKeyNumber: FLAG_WHAT_IS_NEW.whiteness_history,
  },
  {
    id: 8,
    title: t("newFeature:8.navLabel"),
    isNew: true,
    isHidden: false,
    key: [
      FLAG_WHAT_IS_NEW.whiteness_inspect,
      FLAG_WHAT_IS_NEW.whiteness_history,
      FLAG_WHAT_IS_NEW.whiteness_result,
    ],
    toGetKeyNumber: FLAG_WHAT_IS_NEW.whiteness_result,
  },
];

export const listFeature = (t) => ({
  1: {
    title: t("newFeature:1.title"),
    type: "newFeature",
    content: (
      <>
        <Stack spacing={3}>
          <Image src={image1} alt="" />

          <div>{t("newFeature:1.content.0")}</div>
          <li>{t("newFeature:1.content.1")}</li>
          <div>{t("newFeature:1.content.2")}</div>
          <Image src={image1_1} alt="" />
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Trans t={t} i18nKey={"newFeature:1.content.3"}>
              <Button variant="contained" startIcon={<Add />} size="small" sx={{ mx: 1 }}>
                add
              </Button>
            </Trans>
          </Stack>
          <Image src={image1_2} alt="" />

          <div>{t("newFeature:1.content.4")}</div>
          <Image src={image1_3} alt="" />
          <div>{t("newFeature:1.content.5")}</div>
          <Image src={image1_4} alt="" />
          <div>{t("newFeature:1.content.6")}</div>
          <Image src={image1_5} alt="" />
          <div>{t("newFeature:1.content.7")}</div>
          <Image src={image1_6} alt="" />
          <li>{t("newFeature:1.content.8")}</li>
          <div>{t("newFeature:1.content.9")}</div>
          <Image src={image1_7} alt="" />
          <div>
            <div>{t("newFeature:1.content.10")}</div>
            <li>{t("newFeature:1.content.11")}</li>
            <li>{t("newFeature:1.content.12")}</li>
            <li>{t("newFeature:1.content.13")}</li>
            <div>{t("newFeature:1.content.14")}</div>
            <div>{t("newFeature:1.content.15")}</div>
          </div>
          <div>
            <div>{t("newFeature:1.content.16")}</div>
            <div>{t("newFeature:1.content.17")}</div>
            <li>{t("newFeature:1.content.18")}</li>
          </div>
          <Image src={image1_8} alt="" />
          <div>{t("newFeature:1.content.19")}</div>
          <Image src={image1_9} alt="" />
        </Stack>
      </>
    ),
  },
  2: {
    title: t("newFeature:2.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={image2} alt="" />
        <div>{t("newFeature:2.content.0")}</div>
        <li>{t("newFeature:2.content.1")}</li>
        <li>{t("newFeature:2.content.2")}</li>
        <li>{t("newFeature:2.content.3")}</li>
        <Stack spacing={3}>
          <div>{t("newFeature:2.content.4")}</div>
          <Image src={image2_1} alt="" />
          <div>{t("newFeature:2.content.5")}</div>
          <Image src={image2_2} alt="" />
          <div>{t("newFeature:2.content.6")}</div>
          <Image src={image2_3} alt="" />
          <div>{t("newFeature:2.content.7")}</div>
        </Stack>
      </>
    ),
  },
  3: {
    title: t("newFeature:3.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={image3} alt="" />
        <li>{t("newFeature:3.content.0")}</li>
      </>
    ),
  },
  4: {
    title: t("newFeature:4.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={image4} alt="" />
        <div>{t("newFeature:4.content.0")}</div>
        <Image src={image4_1} alt="" />
        <div>{t("newFeature:4.content.1")}</div>
      </>
    ),
  },
  5: {
    title: t("newFeature:5.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={image5} alt="" />
        <div>{t("newFeature:5.content.0")}</div>
        <Image src={image5_1} alt="" />
      </>
    ),
  },
  6: {
    title: t("newFeature:6.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={newFeature1_1} alt="" />
        <div>{t("newFeature:6.content.0")}</div>
        <Image src={newFeature1_2} alt="" />
        <div>{t("newFeature:6.content.1")}</div>
      </>
    ),
  },
  7: {
    title: t("newFeature:7.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={newFeature2} alt="" />
        <div>{t("newFeature:7.content.0")}</div>
      </>
    ),
  },
  8: {
    title: t("newFeature:8.title"),
    type: "newFeature",
    content: (
      <>
        <Image src={newFeature3_1} alt="" />
        <div>{t("newFeature:8.content.0")}</div>
        <Image src={newFeature3_2} alt="" />
        <div>{t("newFeature:8.content.1")}</div>
      </>
    ),
  },
});
